export default class MailService {
    constructor($http, appConfig, $q) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
      this.$q = $q;
    }

    mailDpaHistory(contactId) {
      const deferred = this.$q.defer();

      const frm = $('#frmPrint');
      frm.attr('action', this.appConfig.apiServiceBaseUri + `api/mail/dpahistory/${contactId}`);    
      frm.attr('target', null);    
      frm.submit();  
      frm.attr('target', '_blank');          
      window.setTimeout(() => deferred.resolve(), 100);

      return deferred.promise;
    }   
  }
  


// WEBPACK FOOTER //
// ./client/app/common/services/mail.service.js